import { ToastService } from "../../../toastService/ToastService";
import { translate } from "../../../../utils/translator";

const ERROR_HANDLERS = [
    {
        match: ["account_already_exists_with_contact_or_email"],
        type: "error",
        description: "apiErrorResponse.ACCOUNT_ALREADY_EXISTS_WITH_CONTACT_OR_EMAIL"
    },
    {
        match: ["password_should_not_match_previous_password"],
        type: "error",
        description: "apiErrorResponse.PASSWORD_SHOULD_NOT_MATCH_PREVIOUS_PASSWORD"
    },
    {
        match: ["PASSWORD_ALREADY_EXISTS_TRY_TO_LOGIN"],
        type: "error",
        description: "apiErrorResponse.PASSWORD_ALREADY_EXISTS_TRY_TO_LOGIN"
    },
    {
        match: ["invalid_otp"],
        type: "error",
        title: "apiErrorResponse.INVALID_OTP",
        description: "apiErrorResponse.INVALID_OTP_DESC"
    },
    {
        match: ["ACCOUNT_ALREADY_ACTIVATED", "account_already_activated"],
        type: "warning",
        description: "apiErrorResponse.ACCOUNT_ALREADY_ACTIVATED_TITLE"
    },
    {
        match: ["url_expired"],
        type: "error",
        description: "apiErrorResponse.URL_EXPIRED"
    },
    {
        match: ["already exists", "duplicate", "exists", "already exist"],
        type: "warning",
        description: "apiErrorResponse.already_exists"
    },
    {
        match: ["invalid_username_or_password"],
        type: "error",
        description: "apiErrorResponse.INVALID_USERNAME_OR_PASSWORD"
    },
    {
        match: ["invalid_username"],
        type: "error",
        description: "apiErrorResponse.INVALID_USERNAME"
    },
    {
        match: ["required", "invalid"],
        type: "error",
        description: "apiErrorResponse.validation_error"
    },
    {
        match: ["DIGILOCKER_APAAR_SCOPE_NOT_PROVIDED"],
        type: "error",
        title: "apiErrorResponse.PERMISSION_REQUIRED",
        description: "apiErrorResponse.DIGILOCKER_APAAR_SCOPE_NOT_PROVIDED",
    },
    {
        match: ["CERTIFICATE_ALREADY_ADDED_WITH_THIS_SKILL"],
        type: "warning",
        description: "apiErrorResponse.CERTIFICATE_ALREADY_ADDED_WITH_THIS_SKILL",
    }

];

const getErrorConfig = (message = "") => {
    const msg = message.toLowerCase();

    return ERROR_HANDLERS.find((item) =>
        item.match.some((keyword) =>
            msg.includes(keyword.toLowerCase())
        )
    );
};

export const handlerCustomErrorMessage = (errorMessage, swalAlertFire, error) => {
    const errorConfig = getErrorConfig(errorMessage);

    if (swalAlertFire) {
        return error(translate(errorConfig.description || ""), translate(errorConfig.title || ""));
    }

    // If no custom match found
    if (!errorConfig) {
        return ToastService.error({
            description: translate(`apiErrorResponse.${errorMessage}`)
        });
    }

    const { type, title, description } = errorConfig;

    ToastService[type]({
        title: title && translate(title),
        description: description ? translate(description) : translate(`apiErrorResponse.${errorMessage}`)
    });
};